import React from 'react'

type LaundryAndIroningProps = {
  className?: string
}

const _LaundryAndIroning = (props: LaundryAndIroningProps) => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 0H20C22.2091 0 24 1.79086 24 4V21C24 23.2091 22.2091 25 20 25H4C1.79086 25 0 23.2091 0 21V7V4C0 1.79086 1.79086 0 4 0H9ZM2 21V7H5C7.20914 7 9 5.20914 9 3V2H20C21.1046 2 22 2.89543 22 4V21C22 22.1046 21.1046 23 20 23H4C2.89543 23 2 22.1046 2 21ZM4 2H7V3C7 3.36429 6.90261 3.70583 6.73244 4C6.38663 4.5978 5.74028 5 5 5H2V4C2 3.63571 2.09739 3.29417 2.26756 3C2.29089 2.95968 2.31558 2.92026 2.34157 2.88178C2.70098 2.34978 3.30964 2 4 2ZM12 18.8333C14.1295 18.8333 15.9003 17.2972 16.2647 15.2726L15.6564 15.6294C14.7453 16.1635 13.6169 16.1574 12.7117 15.6132L11.8801 15.1132C11.5971 14.9431 11.2444 14.941 10.9596 15.1081L10.0708 15.6294C9.40936 16.0171 8.63332 16.1201 7.91142 15.9393C8.50483 17.625 10.1113 18.8333 12 18.8333ZM15.5416 13.3966C15.7253 13.2889 15.9177 13.2032 16.1154 13.1394C15.5448 11.4127 13.9179 10.1667 12 10.1667C9.89039 10.1667 8.13287 11.6742 7.74593 13.6707L8.14858 13.9128C8.43091 14.0826 8.78277 14.0846 9.06734 13.9178L9.95603 13.3966C10.8675 12.8621 11.9968 12.8682 12.9025 13.4129L13.7341 13.9128C14.0165 14.0826 14.3685 14.0845 14.6528 13.9179L15.5416 13.3966ZM12 21C15.5899 21 18.5 18.0899 18.5 14.5C18.5 10.9101 15.5899 8 12 8C8.41015 8 5.5 10.9101 5.5 14.5C5.5 18.0899 8.41015 21 12 21ZM20 5C20 5.55228 19.5523 6 19 6C18.4477 6 18 5.55228 18 5C18 4.44772 18.4477 4 19 4C19.5523 4 20 4.44772 20 5ZM12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6H15C15.5523 6 16 5.55228 16 5C16 4.44772 15.5523 4 15 4H12Z"
      fill="currentColor"
    />
  </svg>
)

export default React.memo(_LaundryAndIroning)
